(() => {
  'use strict';
  function shippingState(total, currency = 'AUD') {
    if (currency !== 'AUD') return {text:'The free-shipping threshold is $75 AUD for delivery within Australia.', value:0, showProgress:false};
    if (!Number.isFinite(total)) return {text:'Check your bag for the latest total.', value:0, showProgress:false};
    const remaining = Math.max(0, 7500 - total);
    return {text:remaining ? `You are $${(remaining / 100).toFixed(2)} away from free shipping Australia-wide.` : 'Your order qualifies for free shipping Australia-wide.', value:Math.min(7500, Math.max(0, total)), showProgress:true};
  }
  function orderedMedia(product) {
    const media = product.media?.length ? product.media : product.images.map(image => ({...image, type:'image'}));
    return [...media.filter(item => item.type === 'video' || item.type === 'external_video'), ...media.filter(item => item.type === 'image')];
  }
  function videoSources(sources) {
    return (Array.isArray(sources) ? sources : []).filter(s => s && typeof s.url === 'string' && /^(https?:)?\/\//.test(s.url))
      .map(s => ({...s, url:s.url.startsWith('//') ? 'https:'+s.url : s.url}))
      .sort((a,b) => {
        const mp4 = s => s.format === 'mp4' || s.mime_type === 'video/mp4' || /\.mp4(?:[?#]|$)/i.test(s.url);
        if (mp4(a) !== mp4(b)) return mp4(a) ? -1 : 1;
        const rank = s => s.height && s.height > 1080 ? -s.height : (s.height || 0);
        return rank(b)-rank(a);
      });
  }
  const route = () => window.Shopify?.routes?.root || '/';
  const esc = value => String(value || '').replace(/[&<>"']/g, c => ({'&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;'}[c]));
  let refreshSequence = 0;
  function updateShipping(total, currency) {
    document.querySelectorAll('[data-shop]').forEach(root => {
      const state = shippingState(total, currency);
      const label = root.querySelector('[data-shipping]');
      const progress = root.querySelector('[data-shipping-progress]');
      if (label) label.textContent = state.text;
      if (progress) { progress.value = state.value; progress.hidden = !state.showProgress; }
    });
  }
  async function refreshCart() {
    if (window.BEE_PREVIEW) return;
    const sequence = ++refreshSequence;
    try {
      const response = await fetch(route() + 'cart.js', {headers:{Accept:'application/json'}, cache:'no-store'});
      if (!response.ok) throw Error('Cart unavailable');
      const cart = await response.json();
      if (sequence !== refreshSequence) return;
      document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
      updateShipping(cart.total_price, cart.currency);
    } catch (error) {
      if (sequence === refreshSequence) updateShipping(NaN, 'AUD');
    }
  }
  function init() {
    document.querySelectorAll('[data-shop]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const q = selector => root.querySelector(selector);
      let catalog;
      try { catalog = JSON.parse(q('[data-catalog]').textContent); }
      catch (error) { q('[data-empty]').hidden = false; q('.product-layout').hidden = true; return; }
      const initial = shippingState(Number(root.dataset.cartTotal || 0), root.dataset.currency || 'AUD');
      q('[data-shipping]').textContent = initial.text;
      q('[data-shipping-progress]').value = initial.value;
      q('[data-shipping-progress]').hidden = !initial.showProgress;
      if (!catalog.length) { q('[data-empty]').hidden = false; q('.product-layout').hidden = true; return; }
      const categories = [...new Set(catalog.map(p => p.category))];
      let category = categories[0], product = catalog[0], slide = 0, pending = false;
      function photo() {
        const media = orderedMedia(product), item = media[slide], host = q('[data-media]');
        host.querySelector('video')?.pause();
        host.replaceChildren();
        q('[data-prev]').hidden = q('[data-next]').hidden = media.length < 2;
        if (item?.type === 'video') {
          const video = document.createElement('video');
          video.autoplay = true; video.muted = true; video.defaultMuted = true; video.loop = true;
          video.playsInline = true; video.controls = true; video.preload = 'metadata';
          video.setAttribute('muted', ''); video.setAttribute('playsinline', '');
          video.setAttribute('aria-label', item.alt || product.title);
          if (item.poster) video.poster = item.poster;
          const sources = videoSources(item.sources);
          for (const source of sources) {
            const node = document.createElement('source');
            node.src = source.url;
            if (source.mime_type) node.type = source.mime_type;
            else if (source.format === 'mp4' || /\.mp4(?:[?#]|$)/i.test(source.url)) node.type = 'video/mp4';
            video.append(node);
          }
          if (!sources.length) {
            const message = document.createElement('p');
            message.textContent = 'Video is currently unavailable. Use the arrows to view product photos.';
            host.append(message);
            q('[data-photo-caption]').textContent = item.alt || product.title;
            return;
          }
          host.append(video);
          video.play()?.catch(() => { /* Browser preferences may require using the visible play control. */ });
        } else if (item?.type === 'external_video' && ['youtube','vimeo'].includes(item.host)) {
          const frame = document.createElement('iframe'), id = encodeURIComponent(item.external_id);
          frame.src = item.host === 'youtube'
            ? `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&playsinline=1`
            : `https://player.vimeo.com/video/${id}?autoplay=1&muted=1&loop=1&playsinline=1`;
          frame.title = item.alt || product.title;
          frame.allow = 'autoplay; fullscreen; picture-in-picture'; frame.allowFullscreen = true;
          host.append(frame);
        } else if (item) {
          const image = document.createElement('img');
          image.src = item.src; image.alt = item.alt || product.title; image.width = image.height = 1000;
          host.append(image);
        }
        q('[data-photo-caption]').textContent = item ? `${slide+1} / ${media.length} · ${item.alt || product.title}` : 'Photo coming soon';
      }
      function price() {
        const variant = product.variants.find(v => String(v.id) === q('[data-variant]').value);
        q('[data-price]').textContent = variant?.price || '';
        q('[data-add]').disabled = pending || !variant?.available;
        q('[data-add]').textContent = pending ? 'Adding…' : variant?.available ? 'Add to bag ↗' : 'Sold out';
      }
      function render() {
        q('[data-categories]').innerHTML = categories.map(c => `<button type="button" data-cat="${esc(c)}" aria-pressed="${c===category}">${esc(c)}</button>`).join('');
        q('[data-products]').innerHTML = catalog.map((p,i) => p.category===category ? `<button type="button" data-product="${i}" aria-pressed="${p===product}">${esc(p.title)}</button>` : '').join('');
        q('[data-title]').textContent = product.title;
        q('[data-description]').innerHTML = product.description;
        q('[data-variant]').innerHTML = product.variants.map(v => `<option value="${v.id}" ${v.available?'':'disabled'}>${esc(v.title)}${v.available?'':' — Sold out'}</option>`).join('');
        const available = product.variants.find(v => v.available);
        if (available) q('[data-variant]').value = available.id;
        q('[data-variant-label]').hidden = product.variants.length===1 && product.variants[0].title==='Default Title';
        q('[data-colour]').value = ''; q('[data-status]').textContent = ''; slide = 0;
        photo(); price();
      }
      render();
      root.addEventListener('click', event => {
        const cat = event.target.closest('[data-cat]'), chip = event.target.closest('[data-product]');
        if (cat) {category = cat.dataset.cat; product = catalog.find(p => p.category===category); render();}
        if (chip) {product = catalog[Number(chip.dataset.product)]; render();}
        const count = orderedMedia(product).length;
        if (count && event.target.closest('[data-prev]')) {slide = (slide-1+count)%count; photo();}
        if (count && event.target.closest('[data-next]')) {slide = (slide+1)%count; photo();}
      });
      q('[data-variant]').addEventListener('change', price);
      q('[data-colour]').addEventListener('change', () => {
        const index = orderedMedia(product).findIndex(item => item.type==='image' && item.alt?.toLowerCase()===q('[data-colour]').value.toLowerCase());
        if (index>=0) {slide=index; photo();}
      });
      q('[data-add-form]').addEventListener('submit', async event => {
        event.preventDefault(); if (pending) return;
        if (window.BEE_PREVIEW) {q('[data-status]').textContent='Design preview only — adding to bag works after uploading to Shopify.'; return;}
        pending=true; price(); const title=product.title;
        try {
          const response=await fetch(route()+'cart/add.js', {method:'POST',headers:{Accept:'application/json'},body:new FormData(event.target)});
          const data=await response.json();
          if (!response.ok) throw Error(data.description || data.message || 'This item could not be added. Please try again.');
          q('[data-status]').textContent=title+' added to your bag.';
          await refreshCart();
        } catch (error) {
          q('[data-status]').textContent=error.message==='Failed to fetch' ? 'We couldn’t confirm the update. Check your bag before trying again.' : error.message;
        } finally {pending=false; price();}
      });
    });
    if (document.querySelector('[data-shop]')) refreshCart();
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', () => {if(document.querySelector('[data-shop]')) refreshCart();});
  document.addEventListener('visibilitychange', () => {if(!document.hidden && document.querySelector('[data-shop]')) refreshCart();});
  if(document.readyState!=='loading') init();
})();
